<lh-shared-ui-wizard
  [screenHeight]="screenHeight$ | async"
  [config]="wizardConfig$ | async"
  [showStepNumber]="showStepNumber$ | async"
></lh-shared-ui-wizard>
